// Cookie Utility Funktionen

/**
 * Setzt einen Cookie
 * @param {string} name - Cookie Name
 * @param {string} value - Cookie Wert
 * @param {number} days - Ablaufzeit in Tagen (optional, default: 7)
 */
export const setCookie = (name, value, days = 7) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Strict`;
};

/**
 * Liest einen Cookie aus
 * @param {string} name - Cookie Name
 * @param {boolean} silent - Kein Log wenn Cookie nicht gefunden (default: false)
 * @returns {string|null} Cookie Wert oder null
 */
export const getCookie = (name, silent = false) => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) {
      const value = c.substring(nameEQ.length, c.length);
      if (!silent) console.log(`🍪 Cookie gelesen: ${name}=${value}`);
      return value;
    }
  }
  if (!silent) console.log(`🍪 Cookie nicht gefunden: ${name}`);
  return null;
};

/**
 * Löscht einen Cookie
 * @param {string} name - Cookie Name
 */
export const deleteCookie = (name) => {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
};

/**
 * Prüft ob ein Cookie existiert
 * @param {string} name - Cookie Name
 * @returns {boolean}
 */
export const hasCookie = (name) => {
  return getCookie(name) !== null;
};
